import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';
import { stringToFloat } from 'utils/misc';

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup
    .object({
      costCenterId: yup
        .mixed()
        .required(t('validationFieldRequired', { name: t('planUnit') }))
        .transform((val) => parseInt(val, 10)),
      description: yup
        .string()
        .required(t('validationFieldRequired', { name: t('description') })),
      quantity: yup
        .number()
        .required(t('validationFieldRequired', { name: t('quantity') }))
        .transform(stringToFloat)
        .typeError(t('enterAValidNumericValue')),
      directClientHours: yup
        .number()
        .required(t('validationFieldRequired', { name: t('directHours') }))
        .transform(stringToFloat)
        .typeError(t('enterAValidNumericValue')),
      indirectClientHours: yup
        .number()
        .required(t('validationFieldRequired', { name: t('indirectHours') }))
        .transform(stringToFloat)
        .typeError(t('enterAValidNumericValue')),
      organisationHours: yup
        .number()
        .required(
          t('validationFieldRequired', { name: t('organizationHours') })
        )
        .transform(stringToFloat)
        .typeError(t('enterAValidNumericValue')),
      unit: yup
        .string()
        .required(t('validationFieldRequired', { name: t('unit') })),
      validFrom: yup
        .date()
        .nullable()
        .required(t('validationFieldRequired', { name: t('validFrom') })),
      validTo: yup
        .date()
        .nullable()
        .required(t('validationFieldRequired', { name: t('validTo') })),
      functionId: yup
        .mixed()
        .transform((val) => (val ? val.id : ''))
        .required(t('validationFieldRequired', { name: t('function') }))
    })
    .required();
};

export default getSchema;

